import QR from "../../../../assets/QR";
import Hearts from "../../../../assets/Hearts";
import User02 from "../../../../assets/Users02";
import Settings from "../../../../assets/Settings";
import UserPlus from "../../../../assets/UserPlus";
import FaceSmile from "../../../../assets/FaceSmile";
import UserRight2 from "../../../../assets/UserRight2";
import RefreshCCW from "../../../../assets/RefreshCCW";
import Announcement03 from "../../../../assets/Announcement03";
import AnnotationDots from "../../../../assets/AnnotationDots";
import ImageIndentLeft from "../../../../assets/ImageIndentLeft";
import BarChartSquare02 from "../../../../assets/BarChartSquare02";

export const getRolesSubtitle = (roleKey) => {
  switch (roleKey) {
    case "marketing_manager":
      return "Manages all your marketing activities & Promotions.";
    case "store_manager":
      return "Manages all your day to day store operations.";
    case "operation_manager":
      return "Manages all back end operations for your brand.";
    case "franchise_manager":
      return "Owns or manages your franchise outlet.";
    case "zonal_manager":
      return "Heads all your outlets in a particular region or area.";

    default:
      return "";
  }
};

// for stores page

export const storesFilterOptions = [
  {
    value: "store",
    label: "Your Choice",
  },
  {
    value: "state",
    label: "State",
  },
  {
    value: "category",
    label: "Category",
  },
];

export const getFilteredStoresByState = (allActiveStores) => {
  const groupedByState = allActiveStores?.reduce((prev, store) => {
    const state = store?.address?.state;
    if (!prev[state]) {
      prev[state] = { key: state, value: state, stores: [] };
    }
    prev[state]?.stores?.push(store);
    return prev;
  }, {});

  return Object.values(groupedByState);
};

export const getFilteredStoresByCategory = (allActiveStores) => {
  const groupedByCategory = allActiveStores.reduce((acc, store) => {
    const categoryKey = store?.category?.key;
    const categoryValue = store?.category?.value;
    if (!acc[categoryKey]) {
      acc[categoryKey] = { key: categoryKey, value: categoryValue, stores: [] };
    }
    acc[categoryKey].stores.push(store);
    return acc;
  }, {});

  return Object.values(groupedByCategory);
};

// for permissions

export const permissionsList = [
  {
    key: "dashboard",
    color: "#875BF7",
    label: "Dashboard",
    icon: <BarChartSquare02 width={20} height={20} color="#ffffff" />,
    questions: [
      {
        answer: true,
        action: "read",
        field: ["sales"],
        question: "see your sales data on the dashboard?",
        imageForEnabled: "dashboard_sales_enabled.webp",
        imageForDisabled: "dashboard_sales_disabled.webp",
      },
    ],
  },
  {
    key: "campaigns",
    color: "#0BA5EC",
    label: "Campaigns",
    icon: <Announcement03 width={20} height={20} color="#ffffff" />,
    questions: [
      {
        answer: false,
        action: "send",
        field: ["campaign"],
        otherActionsForSameField: ["schedule"], // * this should only be there when only 1 field key is there.
        question: "send or schedule campaigns to your customers?",
        imageForEnabled: "schedule_campaigns_enabled.webp",
        imageForDisabled: "schedule_campaigns_disabled.webp",
      },
    ],
  },
  {
    color: "#FACC15",
    key: "customer_insights",
    label: "Customer Insights",
    icon: <User02 width={20} height={20} color="#ffffff" />,
    questions: [
      {
        answer: false,
        action: "export",
        field: ["customer_list", "customer_activity"],
        question: "export customer list, customer activity data?",
        imageForEnabled: "customer_insights_export_enabled.webp",
        imageForDisabled: "customer_insights_export_disabled.webp",
      },
      {
        answer: false,
        action: "read",
        field: ["customer_profile"],
        question: "see your customer data?",
        imageForEnabled: "customer_profile_enabled.webp",
        imageForDisabled: "customer_profile_disabled.webp",
      },
    ],
  },
  {
    key: "loyalty",
    color: "#EF6820",
    label: "Loyalty",
    icon: <Hearts width={20} height={20} color="#ffffff" />,
    questions: [
      {
        answer: false,
        action: "activate",
        field: ["loyalty"],
        otherActionsForSameField: ["edit"],
        question: "activate/edit loyalty settings?",
        imageForEnabled: "edit_loyalty_enabled.webp",
        imageForDisabled: "edit_loyalty_disabled.webp",
      },
    ],
  },
  {
    color: "#0086C9",
    key: "auto_campaigns",
    label: "Auto Campaigns",
    icon: <RefreshCCW width={20} height={20} color="#ffffff" />,
    questions: [
      {
        answer: false,
        action: "activate",
        field: ["auto_campaigns"],
        otherActionsForSameField: ["edit"],
        question: "edit or activate auto campaigns?",
        imageForEnabled: "edit_auto_campaigns_enabled.webp",
        imageForDisabled: "edit_auto_campaigns_disabled.webp",
      },
    ],
  },
  {
    key: "feedback",
    color: "#16B364",
    label: "Feedback",
    icon: <FaceSmile width={20} height={20} color="#ffffff" />,
    questions: [
      {
        answer: false,
        action: "activate",
        field: ["feedback"],
        otherActionsForSameField: ["edit"],
        question: "activate/edit feedback settings?",
        imageForEnabled: "edit_fb_settings_enabled.webp",
        imageForDisabled: "edit_fb_settings_disabled.webp",
      },
      {
        answer: false,
        action: "take_action",
        field: ["negative_feedback"],
        question: "take actions on customers negative feedback?",
        imageForEnabled: "take_action_on_fb_enabled.webp",
        imageForDisabled: "take_action_on_fb_disabled.webp",
      },
      {
        answer: false,
        action: "export",
        field: ["feedback"],
        question: "export feedback data?",
        imageForEnabled: "export_feedback_enabled.webp",
        imageForDisabled: "export_feedback_disabled.webp",
      },
    ],
  },
  {
    key: "qr_code",
    color: "#15B79E",
    label: "QR code",
    icon: <QR width={20} height={20} color="#ffffff" />,
    questions: [
      {
        answer: false,
        action: "create",
        field: ["qr_code"],
        otherActionsForSameField: ["edit"],
        question: "create smart QR codes?",
        imageForEnabled: "edit_qr_enabled.webp",
        imageForDisabled: "edit_qr_disabled.webp",
      },
    ],
  },
  {
    key: "referral",
    color: "#F63D68",
    label: "Referral",
    icon: <UserRight2 width={20} height={20} color="#ffffff" />,
    questions: [
      {
        answer: false,
        action: "activate",
        field: ["referral"],
        otherActionsForSameField: ["edit"],
        question: "activate/edit referral settings?",
        imageForEnabled: "edit_referral_enabled.webp",
        imageForDisabled: "edit_referral_disabled.webp",
      },
    ],
  },
  {
    color: "#16B364",
    key: "whatsapp_chat",
    label: "Whatsapp Chat",
    icon: <AnnotationDots width={20} height={20} color="#ffffff" />,
    questions: [
      {
        answer: false,
        action: "read",
        field: ["whatsapp_chat"],
        question: "reply to customers queries from WhatsApp Chat?",
        imageForEnabled: "whatsapp_chat_enabled.webp",
        imageForDisabled: "whatsapp_chat_disabled.webp",
      },
    ],
  },
  {
    key: "add_customers",
    color: "#0BA1A8",
    label: "Add Customer",
    icon: <UserPlus width={20} height={20} color="#ffffff" />,
    questions: [
      {
        answer: false,
        action: "import",
        field: ["customers"],
        question: "import customers and transactions to Reelo?",
        imageForEnabled: "import_cust_trxns_enabled.webp",
        imageForDisabled: "import_cust_trxns_disabled.webp",
      }, // * when submitting API send another object for transaction with action: "delete", field: ["transaction_data"]
      {
        answer: false,
        action: "add_manually",
        field: ["customers"],
        question: "add customers manually via Cashier Portal?",
        imageForEnabled: "add_customers_manually_enabled.webp",
        imageForDisabled: "add_customers_manually_disabled.webp",
      },
    ],
  },
  {
    key: "channels",
    color: "#E45653",
    label: "Channels",
    icon: <Settings width={20} height={20} color="#ffffff" />,
    questions: [
      {
        answer: false,
        action: "export",
        field: ["message_logs"],
        question: "export message logs data?",
        imageForEnabled: "export_message_logs_enabled.webp",
        imageForDisabled: "export_message_logs_disabled.webp",
      },
    ],
  },
  {
    key: "general",
    isHidden: true,
    color: "#0E1B1B",
    label: "General",
    icon: <ImageIndentLeft width={20} height={20} color="#ffffff" />,
    questions: [
      {
        answer: false,
        action: "receive",
        field: ["communication"],
        question:
          "receive product updates and marketing communications via WhatsApp & Emails?",
        imageForEnabled: "general.webp",
        imageForDisabled: "general.webp",
      },
    ],
  },
  {
    isHidden: true,
    key: "store_options",
    label: "Stores Options",
    questions: [
      {
        answer: false,
        action: "select",
        field: ["all_stores"],
      },
    ],
  },
];

export const getPrefilledSeedPermissions = (selectedRoleKey, list) =>
  permissionsList?.map((permission) => {
    const currPermSeedObj = list?.find((feat) => feat?.key === permission?.key);

    if (!currPermSeedObj) return permission;

    const updatedQuestions = permission.questions.map((ques) => {
      let answer = false;

      if (currPermSeedObj?.default_permissions)
        answer = currPermSeedObj?.default_permissions?.[selectedRoleKey];

      if (currPermSeedObj?.key === "customer_insights") {
        const subj = currPermSeedObj?.subjects?.find((subj) =>
          ques?.action === "read"
            ? subj?.key === "customer_profile"
            : subj?.key === ques?.action
        );
        answer = subj?.default_permissions?.[selectedRoleKey];
      }

      if (currPermSeedObj?.key === "feedback") {
        if (ques?.action === "activate") {
          const subj = currPermSeedObj?.subjects?.find(
            (subj) => subj?.key === "activate_edit"
          );
          answer = subj?.default_permissions?.[selectedRoleKey];
        }
        if (ques?.action === "take_action") {
          const subj = currPermSeedObj?.subjects?.find(
            (subj) => subj?.key === "take_action"
          );
          answer = subj?.default_permissions?.[selectedRoleKey];
        }
      }

      if (currPermSeedObj?.key === "add_customers") {
        if (ques?.action === "import") {
          const subj = currPermSeedObj?.subjects?.find(
            (subj) => subj?.key === "via_import"
          );
          answer = subj?.default_permissions?.[selectedRoleKey];
        }
        if (ques?.action === "add_manually") {
          const subj = currPermSeedObj?.subjects?.find(
            (subj) => subj?.key === "cashier_portal"
          );
          answer = subj?.default_permissions?.[selectedRoleKey];
        }
      }

      return {
        ...ques,
        answer: answer,
      };
    });

    return {
      ...permission,
      questions: updatedQuestions,
    };
  });

export const getPrefilledPermissions = (apiPermissionsArr) =>
  permissionsList.map((permission) => {
    const transformedItem = apiPermissionsArr.find(
      (item) => item[permission.key]
    );

    if (!transformedItem) return permission;

    const questions = permission.questions.map((originalQuestion) => {
      const relatedQuestions = transformedItem[permission.key].filter(
        (q) =>
          q.action === originalQuestion.action &&
          q.field.every((f) => originalQuestion.field.includes(f))
      );

      let answer = false;
      if (relatedQuestions.length > 0)
        answer = Boolean(relatedQuestions[0].inverted);

      return {
        ...originalQuestion,
        answer: answer,
      };
    });

    return {
      ...permission,
      questions: questions,
    };
  });

export const getSubmittedPermissions = (permissions, isAllStoresSelected) =>
  permissions.reduce((acc, perm) => {
    const key = perm.key;
    const questions = [];

    perm.questions.forEach((question) => {
      let baseQuestion = {
        inverted: question.answer,
        action: question.action,
        subject: perm.label.replace(/\s/g, ""),
        field: question.field,
      };

      if (
        perm.key === "referral" ||
        perm.key === "whatsapp_chat" ||
        perm.key === "auto_campaigns"
      ) {
        baseQuestion = {
          ...baseQuestion,
          inverted: isAllStoresSelected ? baseQuestion.inverted : false,
        };
      }

      // Handle condition for otherActionsForSameField
      if (question.otherActionsForSameField) {
        questions.push(baseQuestion);
        question.otherActionsForSameField.forEach((action) => {
          questions.push({ ...baseQuestion, action });
        });
      } else if (question.field.length > 1) {
        // Handle condition for multiple fields
        question.field.forEach((field) => {
          questions.push({ ...baseQuestion, field: [field] });
        });
      } else if (perm.key === "add_customers" && question.action === "import") {
        // Handle special condition for add_customers import action
        questions.push(baseQuestion);
        questions.push({
          ...baseQuestion,
          action: "delete",
          field: ["transaction_data"],
        });
      } else if (perm.key === "store_options") {
        // Handle condition for store_options key
        questions.push({
          ...baseQuestion,
          inverted: isAllStoresSelected ?? baseQuestion?.inverted,
        });
      } else {
        questions.push(baseQuestion);
      }
    });

    acc.push({ [key]: questions });
    return acc;
  }, []);

export const existingSeparateAccPerm = [
  {
    dashboard: [
      {
        inverted: true,
        action: "read",
        subject: "Dashboard",
        field: ["sales"],
      },
    ],
  },
  {
    campaigns: [
      {
        inverted: false,
        action: "send",
        subject: "Campaigns",
        field: ["campaign"],
      },
      {
        inverted: false,
        action: "schedule",
        subject: "Campaigns",
        field: ["campaign"],
      },
    ],
  },
  {
    customer_insights: [
      {
        inverted: true,
        action: "export",
        subject: "CustomerInsights",
        field: ["customer_list"],
      },
      {
        inverted: true,
        action: "export",
        subject: "CustomerInsights",
        field: ["customer_activity"],
      },
      {
        inverted: true,
        action: "read",
        subject: "CustomerInsights",
        field: ["customer_profile"],
      },
    ],
  },
  {
    loyalty: [
      {
        inverted: false,
        action: "activate",
        subject: "Loyalty",
        field: ["loyalty"],
      },
      {
        inverted: false,
        action: "edit",
        subject: "Loyalty",
        field: ["loyalty"],
      },
    ],
  },
  {
    auto_campaigns: [
      {
        inverted: false,
        action: "activate",
        subject: "AutoCampaigns",
        field: ["auto_campaigns"],
      },
      {
        inverted: false,
        action: "edit",
        subject: "AutoCampaigns",
        field: ["auto_campaigns"],
      },
    ],
  },
  {
    feedback: [
      {
        inverted: false,
        action: "activate",
        subject: "Feedback",
        field: ["feedback"],
      },
      {
        inverted: false,
        action: "edit",
        subject: "Feedback",
        field: ["feedback"],
      },
      {
        inverted: true,
        action: "take_action",
        subject: "Feedback",
        field: ["negative_feedback"],
      },
      {
        inverted: true,
        action: "export",
        subject: "Feedback",
        field: ["feedback"],
      },
    ],
  },
  {
    qr_code: [
      {
        inverted: true,
        action: "create",
        subject: "QRcode",
        field: ["qr_code"],
      },
      {
        inverted: true,
        action: "edit",
        subject: "QRcode",
        field: ["qr_code"],
      },
    ],
  },
  {
    referral: [
      {
        inverted: false,
        action: "activate",
        subject: "Referral",
        field: ["referral"],
      },
      {
        inverted: false,
        action: "edit",
        subject: "Referral",
        field: ["referral"],
      },
    ],
  },
  {
    add_customers: [
      {
        inverted: true,
        action: "import",
        subject: "AddCustomer",
        field: ["customers"],
      },
      {
        inverted: true,
        action: "delete",
        subject: "AddCustomer",
        field: ["transaction_data"],
      },
      {
        inverted: true,
        action: "add_manually",
        subject: "AddCustomer",
        field: ["customers"],
      },
    ],
  },
  {
    channels: [
      {
        inverted: true,
        action: "export",
        subject: "Channels",
        field: ["message_logs"],
      },
    ],
  },
  {
    general: [
      {
        inverted: true,
        action: "receive",
        subject: "General",
        field: ["communication"],
      },
    ],
  },
  {
    store_options: [
      {
        inverted: false,
        action: "select",
        subject: "StoresOptions",
        field: ["all_stores"],
      },
    ],
  },
];
